import {
  WalletClient,
  type RedeemResult,
  type Wallet,
  type WelcomeGift,
} from "@infrastructure/clients/http/clients/wallet.client";
import { catchError } from "@shared/utils/errors/catchError";
import { getTouchpointCode } from "@shared/utils/analytics";

const WELCOME_CLAIMED_KEY = "phodo_welcome_claimed";

/**
 * Кошелёк: баллы и бесплатная печать, плюс подарок за первую регистрацию.
 */
class WalletServiceClass {
  async get(): Promise<Wallet> {
    const client = new WalletClient();
    const [error, result] = await catchError(client.getWallet());
    if (error) throw error;
    return result.data;
  }

  /**
   * Обменять промокод на награду.
   *
   * Отказ приходит причиной, а не ошибкой: приложению нужно показать, что именно
   * не так — код не найден, истёк, уже использован или это код на скидку.
   */
  async redeem(code: string): Promise<RedeemResult> {
    const client = new WalletClient();
    const [error, result] = await catchError(client.redeem(code));
    if (error) throw error;
    return result.data;
  }

  async welcome(): Promise<WelcomeGift> {
    const client = new WalletClient();
    const [error, result] = await catchError(client.getWelcome());
    if (error) throw error;
    return result.data;
  }

  /**
   * Забрать подарок, обещанный материалом, с которого человек пришёл.
   *
   * Вызывается после входа. Отметка о попытке хранится локально, чтобы не слать
   * запрос при каждом запуске: на сервере подарок всё равно выдаётся один раз, но
   * лишний запрос при старте не нужен.
   *
   * Отказ — не ошибка: материал мог ничего не обещать, а человек мог получить
   * своё раньше или зарегистрироваться давно. Проверяет это сервер.
   */
  async claimWelcome(): Promise<WelcomeGift | null> {
    const code = getTouchpointCode();
    if (!code || localStorage.getItem(WELCOME_CLAIMED_KEY) === code) {
      return null;
    }

    const client = new WalletClient();
    const [error, result] = await catchError(client.claimWelcome(code));
    localStorage.setItem(WELCOME_CLAIMED_KEY, code);

    if (error) return null;
    return result.data;
  }
}

export const WalletService = new WalletServiceClass();
